module.exports = __webpack_public_path__ + "img/tubiao-12.506b2ef7.png";